import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SessionService } from 'app/core/services/session.service';

@Component({
	selector: 'itpx-credit-edit',
	templateUrl: './credit-edit.component.html',
	styleUrls: ['./credit-edit.component.css']
})
export class CreditEditComponent implements OnInit {

	private userGroups: any;

	constructor(
		private router: Router,
		private sessionService: SessionService
	) { }

	ngOnInit() {
	}

}



// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/credit/edit/credit-edit.component.ts